import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "q-ml-sm show-on-hover-child"
}

import { FlexBox, IconButton } from "@/components";


/**
 * A input that pops up over the edited content.
 */
const __default__ = {
  name: "PopupEditInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: {},
    disabled: { type: Boolean },
    editing: { type: [Boolean, null] },
    multiline: { type: Boolean },
    fullWidth: { type: Boolean }
  },
  emits: ["open", "close", "save"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_popup_edit = _resolveComponent("q-popup-edit")!

  return (_openBlock(), _createBlock(_unref(FlexBox), {
    "full-width": props.fullWidth,
    class: "show-on-hover-parent"
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "icon"),
      _createElementVNode("div", {
        class: _normalizeClass(props.fullWidth ? 'full-width' : undefined)
      }, [
        _createVNode(_unref(FlexBox), {
          "full-width": props.fullWidth,
          align: "center",
          justify: "between"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _renderSlot(_ctx.$slots, "default")
            ]),
            (!props.disabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_unref(IconButton), {
                    small: "",
                    icon: "edit",
                    tooltip: "Edit",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('open')))
                  }),
                  _renderSlot(_ctx.$slots, "actions")
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 3
        }, 8, ["full-width"]),
        _renderSlot(_ctx.$slots, "body"),
        (props.editing)
          ? (_openBlock(), _createBlock(_component_q_popup_edit, {
              key: 0,
              "model-value": _ctx.value,
              onHide: _cache[1] || (_cache[1] = ($event: any) => (emit('close'))),
              onSave: _cache[2] || (_cache[2] = (newValue) => emit('save', newValue))
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_q_input, {
                  modelValue: scope.value,
                  "onUpdate:modelValue": ($event: any) => ((scope.value) = $event),
                  autogrow: props.multiline,
                  type: props.multiline ? 'textarea' : undefined,
                  dense: "",
                  class: "full-width"
                }, {
                  append: _withCtx(() => [
                    _createVNode(_unref(IconButton), {
                      small: "",
                      icon: "save",
                      tooltip: "Save",
                      onClick: scope.set
                    }, null, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "autogrow", "type"])
              ]),
              _: 1
            }, 8, ["model-value"]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 3
  }, 8, ["full-width"]))
}
}

})